import { onDocumentReady } from '../utils/events';
/* global ajax_object */

onDocumentReady(() => {
  const ajaxBlocks = document.querySelectorAll('.ajax-posts');

  ajaxBlocks.forEach((block) => {
    const inner = block.querySelector('.ajax-posts__inner');
    const pagination = block.querySelector('.ajax-posts__pagination');

    const postType = block.dataset.postType;
    const postsPerPage = parseInt(block.dataset.postsPerPage) || 6;
    const taxonomy = block.dataset.taxonomy || '';
    let taxonomyTerm = block.dataset.taxonomyTerm || '';

    const loadPosts = (page = 1, term = '') => {
      block.classList.add('loading');
      const formData = new FormData();
      formData.append('action', 'ajax_load_posts');
      formData.append('post_type', postType);
      formData.append('posts_per_page', postsPerPage);
      formData.append('taxonomy', taxonomy);
      formData.append('term', term);
      formData.append('page', page);

      fetch(ajax_object.ajax_url, {
        method: 'POST',
        body: formData,
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.success) {
            inner.innerHTML = data.posts_html;
            pagination.innerHTML = data.pagination_html;
          }
        })
        .catch((err) => {
          console.error('AJAX load error:', err);
        })
        .finally(() => {
          block.classList.remove('loading');
        });
    };

    pagination.addEventListener('click', (e) => {
      const link = e.target.closest('a');
      if (!link) return;
      e.preventDefault();
      const page = parseInt(link.dataset.page);
      if (page) loadPosts(page, taxonomyTerm);
    });

    block.addEventListener('click', (e) => {
      const filterBtn = e.target.closest('[data-term]');
      if (!filterBtn) return;

      e.preventDefault();

      taxonomyTerm = filterBtn.dataset.term;

      block
        .querySelectorAll('[data-term]')
        .forEach((btn) => btn.classList.remove('is-active'));

      filterBtn.classList.add('is-active');

      loadPosts(1, taxonomyTerm);
    });

    loadPosts();
  });
});
